import * as types from '../constants/action-types';
export const setWorkflow = (workflow) => ({
    type: types.SET_SURVEY_WORKFLOW,
    payload: workflow,
});
